<template>
  <v-container fluid class="mt-4 ml-2">
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="text-subtitle-1 flex-wrap">
            Nuevos ingresos (NI) por ciclo — conversaciones marketing
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              small
              tile
              class="mr-2"
              :loading="cargar"
              @click="consultar()"
            >
              <v-icon left small>mdi-magnify</v-icon>
              Consultar
            </v-btn>
            <v-btn
              color="teal darken-1"
              dark
              small
              tile
              class="mr-2"
              :loading="cargarExport"
              :disabled="!inscritos.length"
              @click="exportarJson(true)"
            >
              <v-icon left small>mdi-download-multiple</v-icon>
              JSON todo
            </v-btn>
            <v-btn
              color="green darken-1"
              dark
              small
              tile
              :loading="cargarExport"
              :disabled="!seleccionados.length"
              @click="exportarJson(false)"
            >
              <v-icon left small>mdi-download</v-icon>
              JSON seleccionados ({{ seleccionados.length }})
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="escuela"
                  :items="opcionesEscuela"
                  label="Escuela"
                  filled
                  dense
                  hide-details
                  item-text="text"
                  item-value="value"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  v-model="ciclo"
                  :items="ciclosFiltrados"
                  label="Ciclo"
                  filled
                  dense
                  hide-details
                  return-object
                  clearable
                  :loading="cargandoCiclos"
                  item-text="cicloLabel"
                  item-value="id_ciclo"
                  prepend-inner-icon="mdi-calendar-range"
                  no-data-text="No hay ciclos — revisa que el API esté en marcha"
                ></v-autocomplete>
                <div v-if="!cargandoCiclos && !ciclos.length" class="text-caption red--text mt-1">
                  {{ errorCiclos || `No se cargaron ciclos ${escuela === 2 ? 'FAST' : 'INBI'}. Verifica que api-rh esté activo y desplegado.` }}
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-autocomplete
                  v-model="plantel"
                  :items="plantelesFiltrados"
                  label="Plantel (opcional)"
                  filled
                  dense
                  hide-details
                  clearable
                  item-text="plantel"
                  item-value="id_plantel"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-switch
                  v-model="soloCampania"
                  label="Solo con campaña"
                  dense
                  hide-details
                  class="mt-1"
                ></v-switch>
              </v-col>
            </v-row>

            <v-row v-if="meta" dense class="mt-2">
              <v-col cols="12">
                <div class="text-subtitle-2 mb-1">Nuevos ingresos (NI)</div>
                <v-chip small class="mr-2">NI: {{ meta.total }}</v-chip>
                <v-chip small class="mr-2" color="orange darken-2" dark>Contactados: {{ meta.contactados }}</v-chip>
                <v-chip small class="mr-2" color="teal darken-1" dark>Respondieron: {{ meta.contestaron }}</v-chip>
                <v-chip small class="mr-2" color="blue" dark>Con WhatsApp: {{ meta.con_whatsapp }}</v-chip>
                <v-chip
                  v-if="meta.con_web"
                  small
                  class="mr-2"
                  color="green darken-1"
                  dark
                >Con web: {{ meta.con_web }}</v-chip>
                <v-chip small color="purple" dark>Con campaña: {{ meta.con_campania }}</v-chip>
              </v-col>
              <v-col v-if="meta.total === 0" cols="12">
                <v-alert type="info" dense text class="mb-0">
                  <span v-if="Number(escuela) === 2 && ciclo && Number(ciclo.total_inscritos) === 0">
                    El ciclo {{ ciclo.ciclo }} está abierto pero aún no tiene nuevos ingresos (NI) FAST.
                    Prueba un ciclo anterior o quita el filtro de plantel.
                  </span>
                  <span v-else>
                    No hay nuevos ingresos (NI) en ese ciclo. Prueba otro ciclo, quita el filtro de plantel
                    o desactiva «Solo con campaña».
                  </span>
                </v-alert>
              </v-col>
            </v-row>

            <v-row justify="end" class="mt-2">
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="search"
                  label="Buscar alumno, matrícula, anuncio, URL..."
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              v-model="seleccionados"
              :headers="headers"
              :items="inscritosFiltrados"
              :search="search"
              show-select
              item-key="id_alumno"
              class="elevation-0 mt-2"
              dense
              :loading="cargar"
              :items-per-page="25"
              :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
            >
              <template v-slot:item.tiene_web="{ item }">
                <span
                  v-if="item.tiene_web"
                  class="success--text font-weight-bold text-uppercase"
                >web</span>
              </template>

              <template v-slot:item.tiene_campania="{ item }">
                <v-chip x-small :color="item.tiene_campania ? 'purple' : 'grey'" dark>
                  {{ item.tiene_campania ? 'Sí' : 'No' }}
                </v-chip>
              </template>

              <template v-slot:item.contesto="{ item }">
                <v-chip
                  v-if="item.tiene_whatsapp"
                  x-small
                  :color="item.contesto ? 'green' : 'red'"
                  dark
                >
                  {{ item.contesto ? 'Sí' : 'No' }}
                </v-chip>
                <span v-else class="grey--text">—</span>
              </template>

              <template v-slot:item.campania="{ item }">
                <span v-if="item.campania" class="text-caption">
                  <strong v-if="item.campania.ReferralSourceId">ID: {{ item.campania.ReferralSourceId }}</strong>
                  <span v-if="item.campania.ReferralHeadline"> — {{ truncar(item.campania.ReferralHeadline, 40) }}</span>
                </span>
                <span v-else class="grey--text">—</span>
              </template>

              <template v-slot:item.anuncio="{ item }">
                <span class="text-caption">{{ item.campania ? truncar(item.campania.ReferralBody, 50) : '—' }}</span>
              </template>

              <template v-slot:item.ReferralSourceUrl="{ item }">
                <span
                  v-if="item.ReferralSourceUrl"
                  class="primary--text text-caption"
                  style="cursor: pointer;"
                  @click="previewLink(item)"
                >{{ item.ReferralSourceUrl }}</span>
                <span v-else class="grey--text">—</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  x-small
                  tile
                  color="primary"
                  dark
                  :disabled="!item.tiene_whatsapp"
                  :loading="exportandoId === item.id_alumno"
                  @click="exportarUno(item)"
                >
                  <v-icon x-small>mdi-download</v-icon>
                </v-btn>
              </template>

              <template v-slot:no-data>
                <div class="py-4 grey--text text-center">
                  Selecciona escuela y ciclo, luego pulsa Consultar.
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <v-card v-if="meta" class="shadowCard mt-4">
          <v-card-title class="text-subtitle-1 flex-wrap pb-1">
            WhatsApp — prospectos sin inscripción previa
            <v-spacer></v-spacer>
            <span v-if="metaWhatsapp" class="text-caption grey--text text--darken-1">
              {{ formatFecha(metaWhatsapp.fecha_inicio) }} — {{ formatFecha(metaWhatsapp.fecha_fin) }}
              · {{ contactosWhatsappFiltrados.length }}
            </span>
            <span v-else-if="cargarWhatsapp" class="text-caption grey--text">Cargando…</span>
          </v-card-title>

          <v-card-text class="pt-0">
            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                <v-menu
                  v-model="menuWhatsappDesde"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formatFecha(whatsappFechaDesde)"
                      label="Desde (dd/mm/aaaa)"
                      filled
                      dense
                      hide-details
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      placeholder="dd/mm/aaaa"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="!whatsappLimiteMin || cargarWhatsapp"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="whatsappFechaDesde"
                    locale="es-mx"
                    color="primary"
                    :min="whatsappLimiteMin"
                    :max="whatsappFechaHasta || whatsappLimiteMax"
                    @input="menuWhatsappDesde = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-menu
                  v-model="menuWhatsappHasta"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formatFecha(whatsappFechaHasta)"
                      label="Hasta (dd/mm/aaaa)"
                      filled
                      dense
                      hide-details
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      placeholder="dd/mm/aaaa"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="!whatsappLimiteMax || cargarWhatsapp"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="whatsappFechaHasta"
                    locale="es-mx"
                    color="primary"
                    :min="whatsappFechaDesde || whatsappLimiteMin"
                    :max="whatsappLimiteMax"
                    @input="menuWhatsappHasta = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="d-flex align-center">
                <v-btn
                  color="primary"
                  dark
                  small
                  tile
                  :loading="cargarWhatsapp"
                  :disabled="!ciclo || !meta || !whatsappFechaDesde || !whatsappFechaHasta"
                  @click="aplicarRangoWhatsapp()"
                >
                  <v-icon left small>mdi-calendar-filter</v-icon>
                  Mostrar contactos del rango
                </v-btn>
                <v-btn
                  text
                  small
                  class="ml-2"
                  :disabled="cargarWhatsapp || !whatsappLimiteMin"
                  @click="restablecerRangoWhatsapp()"
                >
                  Todo el ciclo
                </v-btn>
              </v-col>
              <v-col v-if="whatsappLimiteMin" cols="12" class="text-caption grey--text pt-0">
                Rango permitido del ciclo {{ ciclo ? ciclo.ciclo : '' }}:
                {{ formatFecha(whatsappLimiteMin) }} — {{ formatFecha(whatsappLimiteMax) }}
              </v-col>
            </v-row>

            <template v-if="metaWhatsapp">
            <v-row dense class="mt-2">
              <v-col cols="12">
                <v-chip small class="mr-2 mb-1">Teléfonos únicos: {{ metaWhatsapp.telefonos_unicos || metaWhatsapp.total }}</v-chip>
                <v-chip
                  v-if="metaWhatsapp.duplicados_entre_lineas"
                  small
                  class="mr-2 mb-1"
                  color="amber darken-2"
                  dark
                >
                  Duplicados entre líneas eliminados: {{ metaWhatsapp.duplicados_entre_lineas }}
                </v-chip>
                <v-chip small class="mr-2 mb-1" color="red darken-1" dark v-if="metaWhatsapp.excluidos_reingreso">
                  Reingreso excluidos: {{ metaWhatsapp.excluidos_reingreso }}
                </v-chip>
                <v-chip small class="mr-2 mb-1" color="orange darken-2" dark>Contactados: {{ metaWhatsapp.contactados }}</v-chip>
                <v-chip small class="mr-2 mb-1" color="teal darken-1" dark>Respondieron: {{ metaWhatsapp.contestaron }}</v-chip>
                <v-chip
                  v-if="metaWhatsapp.con_web"
                  small
                  class="mr-2 mb-1"
                  color="green darken-1"
                  dark
                >Con web: {{ metaWhatsapp.con_web }}</v-chip>
                <v-chip small class="mb-1" color="purple" dark>Con campaña: {{ metaWhatsapp.con_campania }}</v-chip>
              </v-col>
            </v-row>

            <v-row justify="end" class="mt-1">
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="searchWhatsapp"
                  label="Buscar nombre, teléfono..."
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headersWhatsapp"
              :items="contactosWhatsappFiltrados"
              :search="searchWhatsapp"
              item-key="row_key"
              class="elevation-0 mt-2"
              dense
              :loading="cargarWhatsapp"
              :items-per-page="25"
              :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
            >
              <template v-slot:item.tiene_web="{ item }">
                <span
                  v-if="item.tiene_web"
                  class="success--text font-weight-bold text-uppercase"
                >web</span>
              </template>

              <template v-slot:item.fecha_llegada="{ item }">
                <span class="text-caption">{{ formatFechaHora(item.fecha_llegada) }}</span>
              </template>

              <template v-slot:item.contesto="{ item }">
                <v-chip x-small :color="item.contesto ? 'green' : 'red'" dark>
                  {{ item.contesto ? 'Sí' : 'No' }}
                </v-chip>
              </template>

              <template v-slot:item.contactado="{ item }">
                <v-chip x-small :color="item.contactado ? 'orange' : 'grey'" dark>
                  {{ item.contactado ? 'Sí' : 'No' }}
                </v-chip>
              </template>

              <template v-slot:item.tiene_campania="{ item }">
                <v-chip x-small :color="item.tiene_campania ? 'purple' : 'grey'" dark>
                  {{ item.tiene_campania ? 'Sí' : 'No' }}
                </v-chip>
              </template>

              <template v-slot:no-data>
                <div class="py-4 grey--text text-center">
                  No hay contactos en el rango seleccionado.
                </div>
              </template>
            </v-data-table>
            </template>

            <v-alert
              v-else-if="!cargarWhatsapp"
              type="info"
              dense
              text
              class="mt-3 mb-0"
            >
              Selecciona el rango de fechas y pulsa «Mostrar contactos del rango» para ver la tabla.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogPreview" max-width="600px">
      <v-card>
        <v-card-title class="text-subtitle-1">
          Previsualizar publicación
        </v-card-title>
        <v-card-text v-if="dataPreview">
          Link: {{ dataPreview.ReferralSourceUrl }}
          <br><br>
          <iframe :src="dataPreview.ReferralSourceUrl" width="500" height="600"></iframe>
        </v-card-text>
        <v-card-actions>
          <v-btn block color="primary" @click="verEnWEB(dataPreview)">Ver en web</v-btn>
          <v-btn block text @click="dialogPreview = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargarExport" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

export default {
  name: 'PanelInscritosCiclo',

  components: {
    Alerta,
    carga,
  },

  mixins: [validarErrores],

  data: () => ({
    parametros: {
      dialogError: false,
      mensaje: '',
      color: '',
    },
    respuestaAlerta: false,
    cargar: false,
    cargarWhatsapp: false,
    cargarExport: false,
    cargandoCiclos: false,
    errorCiclos: null,
    exportandoId: null,

    escuela: 1,
    ciclo: null,
    plantel: null,
    soloCampania: false,
    search: '',
    searchWhatsapp: '',
    whatsappFechaDesde: null,
    whatsappFechaHasta: null,
    whatsappLimiteMin: null,
    whatsappLimiteMax: null,
    menuWhatsappDesde: false,
    menuWhatsappHasta: false,

    ciclos: [],
    planteles: [],
    inscritos: [],
    contactosWhatsapp: [],
    meta: null,
    metaWhatsapp: null,
    seleccionados: [],
    dialogPreview: false,
    dataPreview: null,

    opcionesEscuela: [
      { text: 'INBI', value: 1 },
      { text: 'FAST', value: 2 },
    ],

    headers: [
      { text: 'Web', value: 'tiene_web', sortable: false, align: 'center' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Alumno', value: 'alumno' },
      { text: 'Plantel', value: 'plantel' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Vendedora', value: 'nombre_vendedora' },
      { text: 'Contestó', value: 'contesto', sortable: false, align: 'center' },
      { text: 'Campaña', value: 'tiene_campania', sortable: false },
      { text: 'ID / título anuncio', value: 'campania', sortable: false },
      { text: 'Preview', value: 'ReferralSourceUrl', sortable: false },
      { text: 'Texto anuncio', value: 'anuncio', sortable: false },
      { text: 'JSON', value: 'actions', sortable: false, align: 'center' },
    ],

    headersWhatsapp: [
      { text: 'Web', value: 'tiene_web', sortable: false, align: 'center' },
      { text: 'Fecha contacto', value: 'fecha_llegada' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Línea WA', value: 'linea_whatsapp' },
      { text: 'Contactado', value: 'contactado', sortable: false, align: 'center' },
      { text: 'Contestó', value: 'contesto', sortable: false, align: 'center' },
      { text: 'Campaña', value: 'tiene_campania', sortable: false },
    ],
  }),

  computed: {
    ciclosFiltrados () {
      return this.ciclos || []
    },

    plantelesFiltrados () {
      return this.planteles || []
    },

    inscritosFiltrados () {
      if (!this.soloCampania) return this.inscritos
      return this.inscritos.filter((i) => i.tiene_campania)
    },

    contactosWhatsappFiltrados () {
      if (!this.soloCampania) return this.contactosWhatsapp
      return this.contactosWhatsapp.filter((c) => c.tiene_campania)
    },
  },

  watch: {
    async escuela () {
      this.ciclo = null
      this.plantel = null
      this.inscritos = []
      this.contactosWhatsapp = []
      this.meta = null
      this.metaWhatsapp = null
      this.reiniciarRangoWhatsapp()
      this.errorCiclos = null
      this.seleccionados = []
      await Promise.all([this.cargarCiclos(), this.cargarPlanteles()])
    },

    ciclo () {
      this.reiniciarRangoWhatsapp()
    },
  },

  async created () {
    await Promise.all([this.cargarCiclos(), this.cargarPlanteles()])
  },

  methods: {
    truncar (texto, max) {
      if (!texto) return ''
      const s = String(texto)
      return s.length > max ? `${s.slice(0, max)}…` : s
    },

    previewLink (item) {
      const url = item.ReferralSourceUrl || (item.campania && item.campania.ReferralSourceUrl)
      if (!url) return
      this.dataPreview = { ReferralSourceUrl: url }
      this.dialogPreview = true
    },

    verEnWEB (item) {
      const url = item && item.ReferralSourceUrl
      if (url) window.open(url, '_blank')
    },

    mensajeErrorHttp (error, fallback) {
      const status = error.response && error.response.status
      const msg = error.response && error.response.data && error.response.data.message
      if (status && msg) return `[${status}] ${msg}`
      if (msg) return msg
      if (error.message === 'Network Error') {
        return 'No hay conexión con api-rh. En local: npm run dev en api-rh (puerto 3004) y npm run serve en rh-front.'
      }
      return fallback
    },

    formatFecha (valor) {
      if (!valor) return '—'
      const s = String(valor).slice(0, 10)
      const [y, m, d] = s.split('-')
      if (!y || !m || !d) return s
      return `${d}/${m}/${y}`
    },

    formatFechaHora (valor) {
      if (!valor) return '—'
      const s = String(valor)
      const [fecha, hora] = s.split(' ')
      return hora ? `${this.formatFecha(fecha)} ${hora.slice(0, 5)}` : this.formatFecha(fecha)
    },

    payloadFiltros () {
      if (!this.ciclo) {
        this.validarError('Selecciona un ciclo')
        return null
      }
      return {
        escuela: this.escuela,
        id_ciclo: this.ciclo.id_ciclo,
        id_ciclo_relacionado: this.ciclo.id_ciclo_relacionado || this.ciclo.id_ciclo,
        idplantel: this.plantel != null && this.plantel !== '' ? Number(this.plantel) : null,
      }
    },

    payloadWhatsapp () {
      const base = this.payloadFiltros()
      if (!base) return null
      const payload = { ...base }
      if (this.whatsappFechaDesde) payload.fecha_desde = this.whatsappFechaDesde
      if (this.whatsappFechaHasta) payload.fecha_hasta = this.whatsappFechaHasta
      return payload
    },

    reiniciarRangoWhatsapp () {
      this.whatsappFechaDesde = null
      this.whatsappFechaHasta = null
      this.whatsappLimiteMin = null
      this.whatsappLimiteMax = null
      this.menuWhatsappDesde = false
      this.menuWhatsappHasta = false
    },

    prepararRangoWhatsappDesdeLista (meta) {
      const r = meta && meta.whatsapp_rango
      if (!r || !r.fecha_inicio_ciclo_limite || !r.fecha_fin_ciclo_limite) return
      this.whatsappLimiteMin = r.fecha_inicio_ciclo_limite
      this.whatsappLimiteMax = r.fecha_fin_ciclo_limite
      this.whatsappFechaDesde = r.fecha_inicio_ciclo_limite
      this.whatsappFechaHasta = r.fecha_fin_ciclo_limite
    },

    sincronizarRangoWhatsappDesdeMeta () {
      if (!this.metaWhatsapp) return
      const min = this.metaWhatsapp.fecha_inicio_ciclo_limite || this.metaWhatsapp.fecha_inicio
      const max = this.metaWhatsapp.fecha_fin_ciclo_limite || this.metaWhatsapp.fecha_fin
      this.whatsappLimiteMin = min
      this.whatsappLimiteMax = max
      this.whatsappFechaDesde = this.metaWhatsapp.fecha_inicio || min
      this.whatsappFechaHasta = this.metaWhatsapp.fecha_fin || max
    },

    async aplicarRangoWhatsapp () {
      if (!this.ciclo || !this.meta) {
        this.validarError('Consulta un ciclo primero')
        return
      }
      if (!this.whatsappFechaDesde || !this.whatsappFechaHasta) {
        this.validarError('Selecciona fecha desde y hasta')
        return
      }
      if (this.whatsappFechaDesde > this.whatsappFechaHasta) {
        this.validarError('La fecha inicial no puede ser mayor que la final')
        return
      }
      const payload = this.payloadWhatsapp()
      if (!payload) return
      await this.consultarWhatsapp(payload)
    },

    async restablecerRangoWhatsapp () {
      if (!this.whatsappLimiteMin || !this.ciclo || !this.meta) return
      this.whatsappFechaDesde = this.whatsappLimiteMin
      this.whatsappFechaHasta = this.whatsappLimiteMax
      await this.aplicarRangoWhatsapp()
    },

    cicloLabel (ciclo) {
      if (!ciclo) return ''
      const total = Number(ciclo.total_inscritos)
      if (Number.isFinite(total) && total >= 0) {
        return `${ciclo.ciclo} (${total} NI)`
      }
      return ciclo.ciclo || ''
    },

    elegirCicloPorDefecto (lista) {
      const items = lista || []
      if (!items.length) return null
      const conInscritos = items.find((c) => Number(c.total_inscritos) > 0)
      return conInscritos || items[0]
    },

    esPlantelFast (plantel) {
      if (plantel && plantel.escuela != null) return Number(plantel.escuela) === 2
      return String((plantel && plantel.plantel) || '').toUpperCase().includes('FAST')
    },

    async cargarCiclos (reintento = false) {
      this.cargandoCiclos = true
      this.errorCiclos = null
      try {
        const response = await this.$http.get('panel.inscritos.ciclo.ciclos', {
          params: { escuela: this.escuela },
        })
        this.ciclos = (response.data || []).map((c) => ({
          ...c,
          cicloLabel: this.cicloLabel(c),
        }))
        if (!this.ciclos.length) {
          this.errorCiclos = 'El API respondió pero no hay ciclos abiertos para esta escuela.'
        }
        if (!this.ciclo && this.ciclos.length) {
          this.ciclo = this.elegirCicloPorDefecto(this.ciclos)
        }
      } catch (error) {
        if (!reintento) {
          await new Promise((resolve) => setTimeout(resolve, 1000))
          return this.cargarCiclos(true)
        }
        this.ciclos = []
        this.errorCiclos = this.mensajeErrorHttp(error, 'No se pudieron cargar los ciclos')
        this.validarError(this.errorCiclos)
      } finally {
        this.cargandoCiclos = false
      }
    },

    async cargarPlanteles () {
      try {
        const response = await this.$http.get('planteles.activos')
        const esFast = Number(this.escuela) === 2
        this.planteles = (response.data || [])
          .filter((p) => (esFast ? this.esPlantelFast(p) : !this.esPlantelFast(p)))
          .sort((a, b) => String(a.plantel || '').localeCompare(String(b.plantel || '')))
      } catch (error) {
        this.planteles = []
        this.validarError(
          (error.response && error.response.data && error.response.data.message)
            || 'No se pudieron cargar planteles'
        )
      }
    },

    async consultarWhatsapp (payload) {
      this.cargarWhatsapp = true
      this.contactosWhatsapp = []
      this.metaWhatsapp = null
      try {
        const response = await this.$http.post('panel.inscritos.ciclo.contactos', payload)
        this.contactosWhatsapp = response.data.contactos || []
        this.metaWhatsapp = response.data.meta || null
        this.sincronizarRangoWhatsappDesdeMeta()
      } catch (error) {
        this.validarError(
          this.mensajeErrorHttp(error, 'Error al consultar contactos WhatsApp del ciclo')
        )
        this.contactosWhatsapp = []
        this.metaWhatsapp = null
      } finally {
        this.cargarWhatsapp = false
      }
    },

    async consultar () {
      const payload = this.payloadFiltros()
      if (!payload) return

      this.cargar = true
      this.seleccionados = []
      this.inscritos = []
      this.contactosWhatsapp = []
      this.meta = null
      this.metaWhatsapp = null
      this.reiniciarRangoWhatsapp()

      try {
        const response = await this.$http.post('panel.inscritos.ciclo.list', payload)
        this.inscritos = response.data.inscritos || []
        this.meta = response.data.meta || null
        this.prepararRangoWhatsappDesdeLista(this.meta)
      } catch (error) {
        this.validarError(
          this.mensajeErrorHttp(error, 'Error al consultar nuevos ingresos (NI)')
        )
        this.inscritos = []
        this.meta = null
      } finally {
        this.cargar = false
      }
    },

    descargarBlob (data, nombreArchivo) {
      const str = JSON.stringify(data, null, 2)
      const blob = new Blob([str], { type: 'application/json' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = nombreArchivo
      a.click()
      URL.revokeObjectURL(url)
    },

    nombreArchivo (sufijo) {
      const esc = Number(this.escuela) === 2 ? 'FAST' : 'INBI'
      const cicloTxt = this.ciclo ? String(this.ciclo.ciclo).replace(/\s+/g, '_') : 'ciclo'
      return `inscritos_${esc}_${cicloTxt}_${sufijo}.json`
    },

    async exportarJson (todos) {
      const payload = this.payloadFiltros()
      if (!payload) return

      if (!todos && !this.seleccionados.length) {
        this.validarError('Selecciona al menos un inscrito')
        return
      }

      this.cargarExport = true
      try {
        const body = {
          ...payload,
          todos: !!todos,
          id_alumnos: todos ? [] : this.seleccionados.map((i) => i.id_alumno),
        }
        const response = await this.$http.post('panel.inscritos.ciclo.export', body)
        const sufijo = todos ? 'todos' : `sel_${body.id_alumnos.length}`
        this.descargarBlob(response.data, this.nombreArchivo(sufijo))
        this.validarSuccess(
          `Exportados ${(response.data.meta && response.data.meta.total) || 0} inscritos con conversaciones`
        )
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message)
            || 'Error al exportar JSON'
        )
      } finally {
        this.cargarExport = false
      }
    },

    async exportarUno (item) {
      const payload = this.payloadFiltros()
      if (!payload) return

      this.exportandoId = item.id_alumno
      try {
        const body = {
          ...payload,
          todos: false,
          id_alumnos: [item.id_alumno],
        }
        const response = await this.$http.post('panel.inscritos.ciclo.export', body)
        const mat = item.matricula || item.id_alumno
        this.descargarBlob(
          response.data,
          `chat_${mat}_${item.alumno || 'alumno'}.json`.replace(/\s+/g, '_')
        )
      } catch (error) {
        this.validarError(
          (error.response && error.response.data && error.response.data.message)
            || 'Error al descargar conversación'
        )
      } finally {
        this.exportandoId = null
      }
    },
  },
}
</script>
